<script setup lang="ts">
import type { ICellRendererParams } from "ag-grid-community";
import { computed } from "vue";

import DartboardEditor from "~/components/dumb/DartboardEditor.vue";
import PageIcon from "~/components/dumb/PageIcon.vue";
import TaskClickWrapper from "~/components/visualization/components/TaskClickWrapper.vue";
import { EditorMode, ViewKind } from "~/shared/enums";
import type { VisualizationItemTask } from "~/shared/types";
import { useAppStore, useDataStore } from "~/stores";
import { useAsyncTask } from "~/utils/entityIncrementalLoading";

const props = defineProps<{
  params: ICellRendererParams<VisualizationItemTask>;
}>();

const dataStore = useDataStore();
const appStore = useAppStore();

const { task } = useAsyncTask(computed(() => props.params?.data?.duid));
const isSearchAndTaskInTrash = computed(() => appStore.currentPage?.kind === ViewKind.SEARCH && task.value?.inTrash);

const trashPage = computed(() => dataStore.getViewByKind(ViewKind.TRASH));
</script>

<template>
  <TaskClickWrapper v-if="task" :task="task" :editor-mode="EditorMode.LIST">
    <template #default="args">
      <div v-if="isSearchAndTaskInTrash" class="flex size-full max-w-full items-center gap-2 p-1">
        <PageIcon v-if="trashPage" :page="trashPage" />
        <span class="truncate text-start text-sm/5">Trash</span>
      </div>
      <DartboardEditor
        v-else-if="!params.data?.absentee"
        v-bind="args"
        :tasks="[task]"
        :editor-mode="EditorMode.LIST"
        class="h-full p-1" />
    </template>
  </TaskClickWrapper>
</template>
